module.exports = __webpack_public_path__ + "img/icon_study_time.19bec7f9.svg";